import { configureStore } from '@reduxjs/toolkit'
import mantenerListadosReducer from '../reducers/configuracion'
// Ejemplo de uso:
export const store = configureStore({
  reducer: {
    mantenerListados: mantenerListadosReducer,
  },
})
